import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import Editor from '../../Editor';
import cn from 'classnames';
import { extConfig } from './config';
import viewerStyles from '../../../Viewer/presets/Journal/Journal.scss';
import s from './Journal.scss';
const JournalEditor = (props)=>{
    return /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
        withinModal: true,
        presetId: "journal",
        className: cn(s['root'], viewerStyles['root']),
        extensionConfig: extConfig
    }));
};
JournalEditor.displayName = 'JournalEditor';
export default JournalEditor;

//# sourceMappingURL=Journal.js.map